export default __webpack_public_path__ + "static/N0111-4bc99cb54f7193a1125ae5cb69a75a31.png";